import * as types from "./actionTypes";

export function ClearSessionFromRedux() {
    return (dispatch) => {
        dispatch({
            type: types.FLUSH_SESSION_FROM_REDUX,
            data: undefined
        })
    }
}